export default "__VITE_ASSET__DAVHODyB__"